import ContentDescription from "./content_description";
import LocationInformation from "./location_information";
import { formatDecimalNumber } from '../../../services/helpers/formatDecimalNumber'
import logo from "../../../assets/img/Rent-Verde.png";
import './styles.css'

const Pdf = ({ property }) => {
  function generatePDF() {
    var ficha = document.querySelector("#ficha");
    var ventimp = window.open(" ", "popimpr");
    ventimp.document.write(ficha.innerHTML);
    ventimp.document.close();
    ventimp.print();
    ventimp.close();
  }

  if (property?.data?.images.length) {
    let url = property?.data?.images[0].url
  } else {
    let url = ''
  }

  return (
    <div>
      <button
        target="_blank"
        className="btn button-style small-button microcopy-bold text-white"
        onClick={generatePDF}
      >
        Imprimir Ficha
      </button>
      <div id="ficha" className="modal" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <table>
                <tbody>
                  <tr>
                    <td>
                      <img style={{ marginRight: "20px" }} alt='logo' src={logo} />
                    </td>
                    <td>
                      <LocationInformation property={property} />
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
              <br />
              <table>
                <tbody>
                  <tr>
                    <td>
                      <div style={{ marginRight: "20px" }}>
                        <span>
                          <b>Precio desde</b>
                        </span>
                        <br />
                        <span
                          style={{
                            position: "relative",
                            display: "block",
                            fontSize: "30px",
                            lineHeight: "1.2em",
                            color: "#307b29",
                            fontWeight: 700,
                            marginBottom: "5px",
                            textAlign: "right",
                          }}
                        >
                          ${formatDecimalNumber(property?.data?.price.value)}
                        </span>
                        <br />
                        {property?.data?.type && <span>
                          <b>
                            {property?.data.type.name} en{" "}
                            {property?.data.modality.name}
                          </b>
                        </span>}
                        <br />
                      </div>
                    </td>
                    <td>
                      <img style={{ maxWidth: "165px" }} src={property?.data?.images.length && property?.data?.images[0].url} alt='' />
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
              <br />
            </div>
            <div className="modal-body">
              <ContentDescription property={property} />
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pdf;
